<template>
  <form v-if="!loading">
    <DodBorderSection>
      <template v-slot:section-slot>
        <DodAddUserForm
          title="Dane pracownika"
          :extended="true"
          :errorsObj="errorsObject"
          :prePick="employeeData"
          @userDataChange="(e) => (employeeData = e)"
        />
        <dod-view-title
          v-if="isClientDataActive"
          title="Adres zameldowania"
          class="custom-border-top"
        />
        <div v-if="isClientDataActive" class="flex">
          <DodCustomInput
            label="MIEJSCOWOŚĆ"
            :isRequired="true"
            custom-placeholder="Miejscowość"
            :customId="`city-input-additional`"
            class="bigger-input"
            style="margin-bottom: 35px"
            :prePickedValue="additionalCity"
            :errorMsg="errorsObject ? errorsObject.registeredAddressCity : ''"
            @onType="(e) => (additionalCity = e)"
          />
          <DodCustomInput
            label="ULICA"
            custom-placeholder="Ulica"
            :customId="`street-input-additional`"
            class="bigger-input"
            style="margin-bottom: 35px"
            :prePickedValue="additionalStreet"
            @onType="(e) => (additionalStreet = e)"
          />
          <DodCustomInput
            label="NR BUDYNKU"
            :isRequired="true"
            custom-placeholder="Nr budynku"
            :customId="`building-input-additional`"
            class="small-input"
            :prePickedValue="additionalBuildingNumber"
            style="margin-bottom: 35px"
            :errorMsg="
              errorsObject ? errorsObject.registeredAddressStreetNumber : ''
            "
            @onType="(e) => (additionalBuildingNumber = e)"
          />
          <DodCustomInput
            label="NR MIESZKANIA"
            custom-placeholder="Nr mieszkania"
            :customId="`home-number-input-additional`"
            class="small-input"
            :prePickedValue="additionalLocalNumber"
            style="margin-bottom: 35px"
            @onType="(e) => (additionalLocalNumber = e)"
          />
        </div>
        <div style="width: 33%">
          <DodCustomAddButton
            :underlined="isClientDataActive"
            :removePlus="isClientDataActive"
            :title="`${
              isClientDataActive
                ? 'Usuń adres zameldowania'
                : 'Dodaj adres zameldowania'
            }`"
            @click="isClientDataActive = !isClientDataActive"
          />
        </div>
      </template>
    </DodBorderSection>
    <DodBorderSection>
      <template v-slot:section-slot>
        <dod-custom-input
          label="NR KONTA BANKOWEGO"
          :isRequired="true"
          custom-placeholder="Nr konta bankowego"
          customId="bank-account-number"
          style="margin-bottom: 35px"
          :prePickedValue="bankAccountNumber"
          :errorMsg="errorsObject ? errorsObject.accountNumber : ''"
          @onType="(e) => (bankAccountNumber = e)"
        />
      </template>
    </DodBorderSection>
    <DodBorderSection class="flex" style="align-items: center">
      <template v-slot:section-slot>
        <PrimaryInput
          title="STAWKA (BRUTTO) - dotyczy tylko opieki prywatnej"
          placeholder="Kwota za godzinę opieki (brutto)"
          :grayInput="true"
          :isRequired="false"
          :size="'big'"
          :type="'number'"
          :min="0"
          :value="price"
          style="width: 40%; margin-bottom: 35px"
          :errorMsg="errorsObject ? errorsObject.hourlyPriceBrutto : ''"
          @change="(e) => (price = e)"
        />
        <PrimaryInput
          title="STAWKA (BRUTTO) słownie - dotyczy tylko opieki prywatnej"
          placeholder="Kwota za godzinę opieki (brutto) słownie"
          :grayInput="true"
          :isRequired="false"
          :size="'big'"
          :type="'text'"
          :value="priceInWords"
          style="width: 40%; margin-bottom: 35px"
          :errorMsg="errorsObject ? errorsObject.hourlyPriceBruttoInWords : ''"
          @change="(e) => (priceInWords = e)"
        />
        <p
          v-if="isPodPanel"
          style="
            width: 100%;
            padding: 0;
            margin: -20px 0 25px;
            font-size: 12px;
            color: #6b6b7b;
          "
        >
          Stawka nadpisuje stawkę usługi „Prywatna Opieka Domowa" w aplikacji
          SeniorApp dla tego opiekuna (po połączeniu konta).
        </p>

        <div style="padding: 0; margin-bottom: 35px">
          <p class="input-label">
            <span>PREFEROWANY ZAKRES OPIEKI</span
            ><span class="special-char">*</span>
          </p>
          <custom-select
            v-if="scopesOfCares && scopesOfCares.length > 0"
            :options="scopesOfCares"
            :default-value="'Zakres opieki'"
            :special-char="'*'"
            :prePick="careOption"
            :isMultiple="true"
            :errorMsg="errorsObject ? errorsObject.scopesOfCareIds : ''"
            @newPick="(e) => (careOption = e)"
          />
        </div>
      </template>
    </DodBorderSection>
    <DodCustomTextarea
      title="NIESTANDARDOWY ZAKRES"
      placeholder="Niestandardowy zakres usług opiekuńczych"
      :rowsNumber="5"
      :prePick="nonStandardRangeText"
      @change="(e) => (nonStandardRangeText = e)"
    />
    <div>
      <p class="input-label">DYSPOZYCYJNOŚĆ</p>
      <div class="flex" style="justify-content: center">
        <div
          v-for="key in Object.keys(availability)"
          :key="key"
          class="day-input"
        >
          <label :for="`days-input-${key}`">{{ key }}</label>
          <input
            type="checkbox"
            :id="`days-input-${key}`"
            v-model="availability[`${key}`]"
          />
        </div>
      </div>
    </div>
    <div class="flex radio-wrapper">
      <span>Święta: </span>
      <input type="radio" id="yes-radio" :value="true" v-model="isHolidays" />
      <label for="yes-radio">Tak</label>
      <input type="radio" id="no-radio" :value="false" v-model="isHolidays" />
      <label for="no-radio">Nie</label>
    </div>
    <div style="width: 40%; padding: 0; margin-top: 20px">
      <DodCustomInput
        label="MINIMALNA ILOŚĆ GODZIN"
        custom-placeholder="Minimalna il. godz."
        :isRequired="true"
        type="number"
        :prePickedValue="minHours"
        :customId="`minimal-hours-id`"
        :errorMsg="errorsObject ? errorsObject.minimumNumberOfHours : ''"
        style="margin-bottom: 35px"
        @onType="(e) => (minHours = e)"
      />
    </div>
    <div class="flex" style="gap: 30px; margin-top: 20px">
      <DodCustomRadioInput
        title="CZY BYŁA KARANA?"
        :prePick="wasPrisoned"
        @picked="(e) => (wasPrisoned = e)"
      />
      <DodCustomRadioInput
        title="CZY MA KOMORNIKA?"
        :prePick="isBailiff"
        @picked="(e) => (isBailiff = e)"
      />
      <DodCustomRadioInput
        title="CZY POSIADA PRAWO JAZDY?"
        :prePick="isDriver"
        @picked="(e) => (isDriver = e)"
      />
    </div>
    <DodCustomTextarea
      title="NOTATKA"
      placeholder="Wpisz notatkę nt. pracownika"
      :rowsNumber="5"
      :prePick="note"
      @change="(e) => (note = e)"
    />
    <label for="documentFile" style="display: block">
      <div
        class="flex"
        style="align-items: center; justify-content: space-between"
      >
        <p class="input-label" style="font-size: 14px">
          ZAŁĄCZNIKI (UMOWA, DECYZJA)
        </p>
        <img src="../../icons/dod/dodAddPlusIcon.svg" alt="Plus" />
      </div>
      <div class="dashed-square">
        <img src="../../icons/dod/dodDownloadIcon.svg" alt="Download" />
        <input
          type="file"
          id="documentFile"
          style="display: none"
          @change="handleAddFile"
          multiple
        />
      </div>
      <div
        v-if="
          (fileInput && fileInput.length) || filesFetchedFromEmployee.length
        "
        style="margin-left: 10px"
        class="p-0"
      >
        <p v-for="(file, index) in fileInput" :key="index">
          <span>{{ `${file.name} ` }}</span>
          <span
            class="remove-file"
            @click="(e) => handleRemoveFile(e, file.name)"
            >X</span
          >
        </p>
        <p v-for="(file, index) in filesFetchedFromEmployee" :key="index">
          <span>{{ `${file.originalName} ` }}</span>
          <span
            class="remove-file"
            @click="(e) => handleRemoveExistingFile(e, file.name)"
            >X</span
          >
        </p>
      </div>
    </label>

    <p class="input-label mt-4 ml-2" style="font-size: 14px">
      Czy umowa została wysłana?
    </p>
    <div class="contract-line ml-2">
      <input
        type="radio"
        name="contractSent"
        id="contractSentYes"
        :value="true"
        v-model="contractSent"
      />
      <label for="contractSentYes">Tak</label>
    </div>
    <div class="contract-line ml-2">
      <input
        type="radio"
        name="contractSent"
        id="contractSentNo"
        :value="false"
        v-model="contractSent"
      />
      <label for="contractSentNo">Nie</label>
    </div>

    <div
      style="padding: 0; margin-top: 50px"
      class="ml-2"
      v-if="(!employee || !mainAppUser) && panelCan('showMainAppLinking')"
    >
      <p class="ml-2 connect-account-title">
        Połącz konto z profilem SeniorApp
      </p>
      <DodCustomInput
        label="NUMER TELEFONU SENIORAPP"
        custom-placeholder="Telefon (9 cyfr)"
        class="medium-input"
        :digitsOnly="true"
        :maxLength="9"
        :prePickedValue="''"
        @onType="(e) => (mainAppUserPhone = e)"
      />

      <button
        @click="onSubmit($event, true)"
        class="form-item btn btn-outline-dark"
        style="width: 150px"
      >
        Połącz
      </button>
    </div>

    <div
      v-if="employee && employee.mainAppUserId && mainAppUser && panelCan('showMainAppLinking')"
      style="padding: 0; margin-top: 50px"
      class="ml-2"
    >
      <p class="ml-2 connect-account-title">
        Połącz konto z profilem SeniorApp
      </p>

      <div class="connected-user">
        <span style="color: #0ea754">Profil połączono</span>
        <button
          @click="removeMainAppAccount"
          class="form-item btn btn-outline-dark"
          style="width: 150px"
          type="button"
        >
          Rozłącz
        </button>
      </div>
      <profile-preview
        v-if="mainAppUser"
        :name="`${mainAppUser.user_profile.profile.first_name} ${mainAppUser.user_profile.profile.last_name}`"
        :phone="`${mainAppUser.user_profile.user.phone}`"
      />
    </div>

    <custom-button
      :disabled="loading"
      style="margin-left: auto"
      :title="employee ? 'Edytuj' : 'Dodaj'"
      gradient="true"
      custom-styles="border-radius: 50px"
      @click="onSubmit"
    />
    <dod-duplicate-found-modal
      v-if="duplicate"
      :type="'employee'"
      :person="duplicate"
      @back="duplicate = null"
      @goToProfile="openDuplicateProfile"
    />
  </form>
</template>

<script>
import DodBorderSection from "./DodBorderSection";
import DodCustomAddButton from "./DodCustomAddButton";
import DodAddUserForm from "./DodAddUserForm.vue";
import CustomButton from "../CustomButton.vue";
import DodCustomRadioInput from "./DodCustomRadioInput.vue";
import PrimaryInput from "../PrimaryInput.vue";
import CustomSelect from "../CustomSelect";
import DodCustomTextarea from "./DodCustomTextarea.vue";
import DodCustomInput from "./DodCustomInput.vue";
import DodViewTitle from "./DodViewTitle.vue";
import moment from "moment";
import ProfilePreview from "../ProfilePreview.vue";
import DodDuplicateFoundModal from "./DodDuplicateFoundModal.vue";
import mainAppAxios from "../../axios";
import { mainAppSetUserIdPath, PANELS } from "@/config/panels";
import shared from "../../shared";
export default {
  components: {
    DodBorderSection,
    DodCustomAddButton,
    DodAddUserForm,
    CustomButton,
    DodCustomInput,
    DodViewTitle,
    DodCustomRadioInput,
    PrimaryInput,
    CustomSelect,
    DodCustomTextarea,
    ProfilePreview,
    DodDuplicateFoundModal,
  },
  props: ["employee"],
  data() {
    return {
      loading: true,
      employeeData: {},
      duplicate: null,
      isClientDataActive: false,
      additionalCity: "",
      additionalStreet: "",
      additionalBuildingNumber: "",
      additionalLocalNumber: "",
      fileInput: [],
      filesToDelete: [],
      filesFetchedFromEmployee: [],
      bankAccountNumber: "",
      price: "",
      priceInWords: "",
      careOption: [],
      nonStandardRangeText: "",
      note: "",
      minHours: "",
      availability: {
        Pon: false,
        Wt: false,
        Śr: false,
        Czw: false,
        Pt: false,
        Sob: false,
        Nd: false,
      },
      isHolidays: false,
      wasPrisoned: false,
      isBailiff: false,
      isDriver: false,
      isError: false,
      errorsObject: {},
      dateRegexPattern: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])$/,
      emailRegexPattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      contractSent: false,
      mainAppUserPhone: "",
    };
  },
  methods: {
    // Przy dodawaniu zawsze sprawdzamy; przy edycji tylko gdy PESEL faktycznie się zmienił.
    isPeselChanged(pesel) {
      if (!this.employee) {
        return true;
      }
      const clean = (value) => (value || "").replace(/\s+/g, "");
      return clean(pesel) !== clean(this.employee.pesel);
    },
    // Nowa karta, żeby wpisane w formularzu dane nie przepadły - użytkownik może
    // porównać osoby i wrócić do dodawania.
    openDuplicateProfile() {
      const route = this.$router.resolve({
        name: "DodEmployeeDetails",
        params: { id: this.duplicate.id },
      });
      window.open(route.href, "_blank");
    },
    async removeMainAppAccount(e) {
      e.preventDefault();
      // Segment zalezy od panelu: DOD odpina dod/setDodUserId, POD pod/setPodUserId.
      await mainAppAxios.put(
        mainAppSetUserIdPath(this.$activePanel, this.employee.phone),
        {
          id: null,
        }
      );
      this.$store.dispatch("getUserByIdFromMainApp", {
        userId: null,
      });

      window.history.replaceState(
        null,
        "",
        `/dod-add-customer-and-employee?employee=${this.$route.query.employee.replace(
          "mainAppUserId",
          "removedMainAppUserId"
        )}`
      );
    },
    handleAddFile(e) {
      e.target.files.forEach((file) => this.fileInput.push(file));
    },
    handleRemoveFile(event, name) {
      event.preventDefault();
      this.fileInput = this.fileInput.filter((e) => e.name !== name);
    },
    handleCheckErrorsObject(key, errorMsg, isTrue) {
      if (isTrue) {
        this.errorsObject = { ...this.errorsObject, [`${key}`]: errorMsg };
        this.isError = true;
      } else {
        this.errorsObject = { ...this.errorsObject, [`${key}`]: "" };
      }
    },
    handleRemoveExistingFile(event, file) {
      event.preventDefault();
      this.filesToDelete.push(file);
    },
    async onSubmit(e, connectWithMainApp) {
      if (e) {
        e.preventDefault();
      }

      try {
        this.loading = true;
        this.isError = false;

        const fileIds =
          this.fileInput && this.fileInput?.length
            ? await Promise.all(
                this.fileInput.map((file) =>
                  this.$store.dispatch("addDodFile", {
                    file,
                  })
                )
              )
            : null;
        const {
          name,
          surname,
          phone,
          city,
          street,
          buildingNumber,
          houseNumber,
          pesel,
          birthdate,
          taxOffice,
          idNumber,
          passportId,
          careOption,
          lat,
          lng,
          postalCode,
          citizenship,
          email,
        } = this.employeeData;
        const data = {
          firstName: name,
          lastName: surname,
          phone: phone,
          pesel: pesel,
          birthDate: moment(birthdate).format("YYYY-MM-DD"),
          taxOffice: taxOffice,
          idNumber: idNumber,
          latitude: lat || null,
          longitude: lng || null,
          postalCode,
          passportNumber: passportId,
          nfzDepartment: careOption,
          registeredAddressCity: this.additionalCity,
          registeredAddressStreet: this.additionalStreet,
          registeredAddressStreetNumber: this.additionalBuildingNumber,
          registeredAddressHouseNumber: this.additionalLocalNumber,
          accountNumber: this.bankAccountNumber,
          hourlyPriceBrutto: Number(this.price),
          hourlyPriceBruttoInWords: this.priceInWords,
          wasPunished: this.wasPrisoned,
          hasBailiff: this.isBailiff,
          hasDrivingLicense: this.isDriver,
          minimumNumberOfHours: Number(this.minHours),
          availability: {
            monday: this.availability.Pon,
            tuesday: this.availability.Wt,
            wednesday: this.availability.Śr,
            thursday: this.availability.Czw,
            friday: this.availability.Pt,
            saturday: this.availability.Sob,
            sunday: this.availability.Nd,
            holidays: this.isHolidays,
          },
          city: city,
          street: street,
          streetNumber: buildingNumber,
          houseNumber: houseNumber,
          scopesOfCareIds: [...this.careOption],
          employeeNote: this.note,
          careScopeNote: this.nonStandardRangeText,
          citizenship: citizenship,
          email: email,
          files:
            fileIds && fileIds.length
              ? [
                  ...fileIds.map((file) => ({
                    fileId: file,
                  })),
                ]
              : [],
          contractSent: this.contractSent,
          mainAppUserPhone: this.mainAppUserPhone,
          connectWithMainApp: connectWithMainApp,
        };
        this.handleCheckErrorsObject(
          "firstName",
          "Podaj imię",
          !data.firstName
        );
        this.handleCheckErrorsObject(
          "lastName",
          "Podaj nazwisko",
          !data.lastName
        );
        this.handleCheckErrorsObject(
          "phone",
          "Podaj numer telefonu w formacie 9 cyfr",
          !/^\d{9}$/.test(data.phone)
        );
        // PESEL jest kluczem wykrywania duplikatu opiekuna, więc musi być poprawny -
        // walidacja (11 cyfr + suma kontrolna) jak w Opiece w Terenie.
        this.handleCheckErrorsObject(
          "pesel",
          !data.pesel ? "Podaj numer pesel" : "Nieprawidłowy numer PESEL",
          !data.pesel || !shared.isValidPesel(data.pesel)
        );
        this.handleCheckErrorsObject(
          "birthDate",
          "Podaj datę urodzenia (YYYY-MM-DD)",
          !this.dateRegexPattern.test(this.employeeData.birthdate)
        );
        this.handleCheckErrorsObject(
          "email",
          "Podaj prawidłowy email",
          this.employeeData.email &&
            !this.emailRegexPattern.test(this.employeeData.email)
        );
        this.handleCheckErrorsObject(
          "taxOffice",
          "Podaj urząd skarbowy",
          !data.taxOffice
        );
        this.handleCheckErrorsObject(
          "idNumber",
          "Podaj numer dowodu",
          !data.passportNumber && !data.idNumber
        );
        this.handleCheckErrorsObject(
          "passportNumber",
          "Podaj numer paszportu",
          !data.passportNumber && !data.idNumber
        );
        this.handleCheckErrorsObject("city", "Podaj miejscowość", !data.city);
        this.handleCheckErrorsObject(
          "streetNumber",
          "Podaj nr budnyku",
          !data.streetNumber
        );
        this.handleCheckErrorsObject(
          "registeredAddressCity",
          "Podaj miejscowość",
          !data.registeredAddressCity && this.isClientDataActive
        );

        this.handleCheckErrorsObject(
          "registeredAddressStreetNumber",
          "Podaj nr budnyku",
          !data.registeredAddressStreetNumber && this.isClientDataActive
        );
        this.handleCheckErrorsObject(
          "accountNumber",
          "Podaj nr konta",
          !data.accountNumber
        );
        // this.handleCheckErrorsObject(
        //   "hourlyPriceBrutto",
        //   "Podaj kwotę za godzinę",
        //   !data.hourlyPriceBrutto
        // );
        this.handleCheckErrorsObject(
          "scopesOfCareIds",
          "Podaj zakres opieki",
          !data.scopesOfCareIds.length
        );
        this.handleCheckErrorsObject(
          "minimumNumberOfHours",
          "Podaj minimalną ilość godzin",
          !data.minimumNumberOfHours
        );
        if (!this.isError) {
          // Duplikat po numerze PESEL blokujemy tak samo przy dodawaniu, jak przy edycji -
          // inaczej blokadę da się obejść, zapisując opiekuna z innym PESEL-em i podmieniając
          // go zaraz potem. Przy edycji sprawdzamy tylko, gdy PESEL się zmienia (w bazie są
          // zdublowane numery sprzed tej zmiany - edycja takich profili musi dalej działać).
          if (this.isPeselChanged(data.pesel)) {
            const existing = await this.$store.dispatch(
              "checkEmployeeDuplicate",
              {
                pesel: data.pesel,
                excludeId: this.employee ? this.employee.id : undefined,
              }
            );
            if (existing) {
              this.duplicate = existing;
              return;
            }
          }
          await Promise.all(
            this.filesToDelete.map((file) =>
              this.$store.dispatch("removeDodFile", file.id)
            )
          );
          if (this.employee) {
            const response = await this.$store.dispatch("editDodEmployee", {
              employeeId: this.employee.id,
              data,
            });
            if (response) {
              this.$notify({
                group: "success",
                text: "Opiekun został zedytowany pomyślnie",
              });
              this.$router.push({
                name: "DodEmployeeDetails",
                params: {
                  id: this.employee.id,
                },
              });
              if (this.employeeStatuses && this.employeeStatuses.length > 0) {
                this.$store.dispatch(
                  "setSelectedEmployeeStatus",
                  this.employeeStatuses[0]
                );
              }
            } else {
              throw response;
            }
          } else {
            const response = await this.$store.dispatch("addEmployee", data);
            if (response) {
              this.$notify({
                group: "success",
                text: "Opiekun został dodany pomyślnie",
              });
              this.$router.push({
                name: "Employees",
                query:
                  this.employeeStatuses && this.employeeStatuses.length > 0
                    ? { status: this.employeeStatuses[0].id }
                    : {},
              });
              if (this.employeeStatuses && this.employeeStatuses.length > 0) {
                this.$store.dispatch(
                  "setSelectedEmployeeStatus",
                  this.employeeStatuses[0]
                );
              }
            } else {
              throw response;
            }
          }
        } else {
          this.$notify({
            group: "error",
            text: "Występują błędy w formularzu",
          });
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          group: "error",
          text: "Nie udało się dodać opiekuna",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    if (this.employee) {
      if (this.employee.mainAppUserId) {
        await this.$store.dispatch("getUserByIdFromMainApp", {
          userId: this.employee.mainAppUserId,
        });
      }

      this.employeeData.name = this.employee.firstName || "";
      this.employeeData.surname = this.employee.lastName || "";
      this.employeeData.phone = this.employee.phone || "";
      this.employeeData.city = this.employee.city || "";
      this.employeeData.street = this.employee.street || "";
      this.employeeData.buildingNumber = this.employee.streetNumber || "";
      this.employeeData.houseNumber = this.employee.houseNumber || "";
      this.employeeData.postalCode = this.employee.postalCode || "";
      this.employeeData.pesel = this.employee.pesel || "";
      this.employeeData.birthdate = this.employee.birthDate
        ? moment(this.employee.birthDate).format("YYYY-MM-DD")
        : "";
      this.employeeData.taxOffice = this.employee.taxOffice || "";
      this.employeeData.idNumber = this.employee.idNumber || "";
      this.employeeData.passportId = this.employee.passportNumber || "";
      this.employeeData.careOption = this.employee.nfzDepartment || "";
      if (this.employee.registeredAddressCity) {
        this.isClientDataActive = true;
        this.additionalCity = this.employee.registeredAddressCity || "";
        this.additionalStreet = this.employee.registeredAddressStreet || "";
        this.additionalBuildingNumber =
          this.employee.registeredAddressStreetNumber || "";
        this.additionalLocalNumber =
          this.employee.registeredAddressHouseNumber || "";
      }
      this.bankAccountNumber = this.employee.accountNumber || "";
      this.price = this.employee.hourlyPriceBrutto || "";
      this.priceInWords = this.employee.hourlyPriceBruttoInWords || "";
      this.careOption = this.employee.scopesOfCare
        ? this.employee.scopesOfCare.map((e) => e.id)
        : [];
      this.nonStandardRangeText = this.employee.careScopeNote || "";
      this.minHours = this.employee.minimumNumberOfHours || "";
      this.availability = {
        Pon: this.employee.availability.monday || false,
        Wt: this.employee.availability.tuesday || false,
        Śr: this.employee.availability.wednesday || false,
        Czw: this.employee.availability.thursday || false,
        Pt: this.employee.availability.friday || false,
        Sob: this.employee.availability.saturday || false,
        Nd: this.employee.availability.sunday || false,
      };
      this.isHolidays = this.employee.availability.holidays || false;
      this.wasPrisoned = this.employee.wasPunished || false;
      this.isBailiff = this.employee.hasBailiff || false;
      this.isDriver = this.employee.hasDrivingLicense || false;
      this.filesFetchedFromEmployee = this.employee.attachments || [];
      this.note = this.employee.employeeNote || "";
      this.employeeData.citizenship = this.employee.citizenship;
      this.employeeData.email = this.employee.email;
      this.contractSent = this.employee.contractSent;
    }
    this.loading = false;
  },

  computed: {
    isPodPanel() {
      return this.$activePanel === PANELS.POD;
    },
    mainAppUser() {
      return this.$store.getters.getMainAppUser;
    },
    scopesOfCares() {
      const scopes = this.$store.getters.getDodScopesOfCare;
      if (scopes && scopes.data) {
        return scopes.data.map((s) => {
          return {
            name: s.name,
            value: s.id,
            shortName: s.name,
          };
        });
      } else {
        return [];
      }
    },
    employeeStatuses() {
      return this.$store.getters.getEmployeeStatuses;
    },
  },
};
</script>

<style scoped>
.input-label {
  color: #090741;
  font-weight: 700;
  font-size: 12px;
  padding-left: 5px;
  margin-bottom: 0;
  margin-top: 5px;
}
.dashed-square {
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  border: 1px dashed #c1c1cf;
  cursor: pointer;
  width: fit-content;
  margin-left: 10px;
}
.custom-border-top {
  border-top: 1px solid #c1c1cf;
  padding-top: 20px;
  margin-top: 30px;
}
.day-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #c1c1cf;
  border-top: 1px solid #c1c1cf;
  border-left: 1px solid #c1c1cf;
  width: 14%;
  padding: 10px 0;
}
.day-input label,
.day-input input {
  cursor: pointer;
  width: 100%;
  text-align: center;
}
.day-input label {
  color: #090741;
  font-size: 14px;
  font-weight: 500;
}
.day-input:nth-last-child(1) {
  border-right: 1px solid #c1c1cf;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.day-input:nth-child(1) {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
input[type="radio"] {
  accent-color: #ec1a6b;
}
.radio-wrapper {
  align-items: center;
  font-size: 16px;
  gap: 5px;
  font-weight: 500;
  color: #090741;
  margin-top: 20px;
}
.radio-wrapper label {
  margin: 0;
  padding: 0;
}
.remove-file {
  color: red;
  cursor: pointer;
}
.contract-line {
  display: flex;
  align-items: center;
}
.contract-line label {
  margin-top: 0.65rem;
  margin-left: 0.5rem;
}
.connect-account-title {
  font-size: 20px;
}
.connected-user {
  display: flex;
  gap: 1rem;
  align-items: center;
}
</style>
